import { gql } from '@apollo/client';

export const GENERATE_TEXT_AUDIO = gql`
  mutation GenerateTextAudio($text: String!, $learningSubject: LearningSubject!) {
    generateTextAudio(text: $text, learningSubject: $learningSubject) {
      fileKey
      fileUrl
    }
  }
`;
